/* SHOEKIDS — size picker, footer accordions, gallery progress */
(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* Theme editor: always show animated blocks, and re-show them after a section is re-rendered */
  const showReveals = (root) => $$('.reveal', root).forEach((el) => el.classList.add('is-in'));
  if (window.Shopify && window.Shopify.designMode) showReveals(document);
  document.addEventListener('shopify:section:load', (e) => showReveals(e.target));
  document.addEventListener('shopify:block:select', (e) => { const s = e.target.closest('.shopify-section'); if (s) showReveals(s); });

  /* Quick add size picker on product cards */
  const closeAll = (except) => $$('.card__sizes').forEach((p) => {
    if (p === except) return;
    p.hidden = true;
    const t = p.parentElement.querySelector('[data-sizes-toggle]');
    if (t) t.setAttribute('aria-expanded', 'false');
  });
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-sizes-toggle]');
    if (toggle) {
      e.preventDefault();
      const panel = toggle.parentElement.querySelector('.card__sizes');
      const open = panel.hidden;
      closeAll(panel);
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }
    if (e.target.closest('[data-sizes-close]')) { closeAll(); return; }
    const size = e.target.closest('.card__size');
    if (size) { setTimeout(() => closeAll(), 900); return; }
    if (!e.target.closest('.card__sizes')) closeAll();
  });

  /* Footer: menus open on desktop, collapsible on mobile */
  const accs = $$('[data-footer-acc]');
  const menus = document.querySelector('.footer__menus');
  if (menus) menus.style.setProperty('--menus', accs.length || 1);
  const syncAcc = () => { const desk = window.innerWidth >= 990; accs.forEach((d) => { if (desk) d.open = true; else if (!d.dataset.touched) d.open = false; }); };
  accs.forEach((d) => d.querySelector('summary').addEventListener('click', () => { d.dataset.touched = '1'; }));
  syncAcc();
  window.addEventListener('resize', syncAcc);

  /* Tattoo gallery progress bar */
  $$('[data-gallery-track]').forEach((track) => {
    const bar = track.parentElement.querySelector('[data-gallery-progress]');
    if (!bar) return;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const visible = track.clientWidth / track.scrollWidth;
      const pos = max > 0 ? track.scrollLeft / max : 1;
      bar.style.width = `${Math.max(visible, 0.12) * 100 + pos * (100 - Math.max(visible, 0.12) * 100)}%`;
    };
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
